import {
  TextInput,
  SelectInput,
  email,
  required,
  useGetList,
  useTranslate,
} from 'react-admin';
import { Alert } from '@mui/material';
import { AUTH_PROVISIONING_ENABLED } from '@/config/constants';

export const ClientFormFields = ({ isCreate }: { isCreate: boolean }) => {
  const translate = useTranslate();
  const { data: plans } = useGetList('plans', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'plan_id', order: 'ASC' },
  });

  return (
    <>
      <TextInput source="full_name" validate={required()} />
      <TextInput source="email" type="email" validate={[required(), email()]} />
      {isCreate && AUTH_PROVISIONING_ENABLED && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {translate('resources.clients.activation_note')}
        </Alert>
      )}
      {isCreate && !AUTH_PROVISIONING_ENABLED && (
        <TextInput
          source="password"
          type="password"
          validate={required()}
          autoComplete="new-password"
        />
      )}
      <TextInput source="company_name" validate={isCreate ? required() : undefined} />
      <TextInput source="contact_no" />
      <SelectInput
        source="plan_id"
        choices={(plans ?? []).map((plan: any) => ({ id: plan.plan_id, name: plan.name }))}
        validate={isCreate ? required() : undefined}
        helperText={isCreate ? translate('resources.clients.plan_help') : undefined}
      />
      {!isCreate && (
        <SelectInput
          source="status"
          choices={[
            { id: 1, name: translate('common.status.active', { _: 'Activo' }) },
            { id: 0, name: translate('common.status.inactive', { _: 'Inactivo' }) },
          ]}
        />
      )}
    </>
  );
};

export default ClientFormFields;
